import config from "../config";
import { FilterOptionEnum, FilterTypeEnum, ServiceEnum } from "../models/dataModel";
function getTermFilterValue(field, fieldValue) {
    // We do this because if the value is a boolean value, we need to apply
    // our filter differently. We're also only storing the string representation
    // of the boolean value, so we need to convert it to a Boolean.
    // TODO We need better approach for boolean values
    if (fieldValue === "false" || fieldValue === "true") {
        return { [field]: fieldValue === "true" };
    }
    return { [`${field}`]: fieldValue };
}
function getTermFilter(filter) {
    const clauses = filter.values.map((filterValue) => {
        const term = { term: getTermFilterValue(filter.field, filterValue) };
        if (filter.field === FilterOptionEnum.CATEGORY &&
            filterValue === config.services[ServiceEnum.TRIMBLE_HELP].categoryName) {
            return {
                bool: {
                    should: [term, { wildcard: { _index: `${ServiceEnum.SKETCHUP_HELP}_*` } }],
                    minimum_should_match: 1,
                },
            };
        }
        return term;
    });
    if (filter.type === FilterTypeEnum.ANY) {
        return {
            bool: {
                should: clauses,
                minimum_should_match: 1,
            },
        };
    }
    else if (filter.type === FilterTypeEnum.ALL) {
        return {
            bool: {
                filter: clauses,
            },
        };
    }
}
export default function buildRequestFilter(service, uiState, filters) {
    if (!filters)
        return;
    const source = uiState.inGlobalSearchMode() ? config.global : config.services[service];
    const openCagegory = uiState.getOpenCategory();
    const allFilters = openCagegory ? source.filters.concat(config.services[openCagegory].filters) : source.filters;
    const termFilters = filters.reduce((acc, filter) => {
        if (allFilters.includes(filter.field)) {
            const termFilter = getTermFilter(filter);
            if (termFilter)
                return [...acc, termFilter];
            else
                return acc;
        }
        return acc;
    }, []);
    if (termFilters.length < 1)
        return;
    return termFilters;
}
